module.exports = __webpack_public_path__ + "static/media/smile-regular-active.37ed5790.svg";